/* eslint-disable no-console */
// import * as testData from './test-data';
import { getParameterByName } from '../../utils/url-utils';

const baseUrl = '';
const digitalUserApi = window.digitalUserApiEndoint;

const addVisualization = (data, callback) => {
  // console.log('account-api.js, addVisualization');
  // console.log(data);
  let dealerIdParam = '';
  if (getParameterByName('dealerid') !== null) {
    dealerIdParam = `?dealerid=${getParameterByName('dealerid')}`;
  }
  const requestUrl = `${digitalUserApi}/visualization/user/${window.userId}/?site=${window.micrositeName}${dealerIdParam}`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'text/plain');
  request.setRequestHeader('Accept', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (callback) {
        callback();
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send(data.toString());
};

const addPhoto = (data, callback) => {
  const {
    imageUrl,
    thumbUrl,
    description,
    productLineId,
    productLineName,
  } = data;
  const requestUrl = `${digitalUserApi}/photo`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send(JSON.stringify({
    'user-id': window.userId,
    'photo-url': imageUrl,
    'thumbnail-url': thumbUrl,
    description,
    'product-line-id': productLineId,
    'product-line-name': productLineName,
  }));
};

const addDealer = (data, callback) => {
  const requestUrl = `${digitalUserApi}/dealer`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send(JSON.stringify({
    'user-id': window.userId,
    'record-id': data['record-id'],
    'ship-to-account': data['ship-to-account'],
  }));
};

const addSwatch = (data, callback) => {
  const {
    productLineCode,
    colorNumber,
    swatchId,
    widenUrl,
  } = data;
  const requestUrl = `${digitalUserApi}/swatch`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send(JSON.stringify({
    'user-id': window.userId,
    'product-line-code': productLineCode,
    'color-number': colorNumber,
    'swatch-id': swatchId,
    'widen-url': widenUrl,
  }));
};

const addSwatches = (data, callbacks) => {
  // console.log('account-api.js, addSwatches');
  const swatchlist = data.map(swatch => ({
    'user-id': window.userId,
    'product-line-code': swatch.productLineCode,
    'color-number': swatch.colorNumber,
    'swatch-id': swatch.swatchId,
    'widen-url': swatch.widenUrl,
  }));
  // console.log(swatchlist);
  const requestUrl = `${baseUrl}/addswatches`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (!callbacks) {
        return;
      }
      if (callbacks.onSuccess) {
        const responseData = JSON.parse(request.responseText);
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (!callbacks) {
      return;
    }
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify({
    data: JSON.stringify({
      swatchlist,
    }),
  }));
};

const removeItemByType = (type, id, callback) => {
  // console.log(`account-api.js, removeItemByType: ${type}, item: ${id}`);
  let requestUrl;
  switch (type) {
    case 'location':
      requestUrl = `${digitalUserApi}/dealer`;
      break;
    case 'photo':
      requestUrl = `${digitalUserApi}/photo`;
      break;
    case 'visualization':
      requestUrl = `${digitalUserApi}/visualization`;
      break;
    case 'swatch':
      requestUrl = `${digitalUserApi}/swatch`;
      break;
    default:
      break;
  }
  const request = new XMLHttpRequest();
  request.open('DELETE', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send(JSON.stringify({
    'asset-id': id,
  }));
};

const getItemsByType = (type, callback) => {
  let requestUrl;
  switch (type) {
    case 'location':
      requestUrl = `${digitalUserApi}/dealer/brand/${window.brandId}/user/${window.userId}`;
      break;
    case 'photo':
      requestUrl = `${digitalUserApi}/photos/user/${window.userId}`;
      break;
    case 'swatch':
      requestUrl = `${digitalUserApi}/swatches/microsite/${window.micrositeName}/user/${window.userId}`;
      break;
    case 'visualization':
      requestUrl = `${digitalUserApi}/visualizations/user/${window.userId}?site=${window.micrositeName}`;
      break;
    default:
      break;
  }
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText.replace(/\\"/gi, '\\"'));
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send();
};

const getAccountData = (callback) => {
  const requestUrl = `${digitalUserApi}/account/${window.userId}`;
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send();
};

const forgotPassword = (data, callbacks) => {
  const {
    username,
  } = data;
  const requestUrl = `${baseUrl}/forgot-password/SendPasswordResetEmail`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (!callbacks) {
        return;
      }
      if (callbacks.onSuccess) {
        const responseData = JSON.parse(request.responseText);
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (!callbacks) {
      return;
    }
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify({
    username,
  }));
};

const login = (data, callbacks) => {
  const {
    username,
    password,
    rememberMe,
  } = data;
  const requestUrl = `${baseUrl}/userlogin`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (!callbacks) {
        return;
      }
      if (callbacks.onSuccess) {
        const responseData = JSON.parse(request.responseText);
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (!callbacks) {
      return;
    }
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify({
    data: JSON.stringify({
      'microsite-name': window.micrositeName,
      username,
      password,
      rememberMe,
    }),
  }));
};

const logout = (callbacks) => {
  const requestUrl = `${baseUrl}/logout`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  // request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      if (!callbacks) {
        return;
      }
      if (callbacks.onSuccess) {
        // const responseData = JSON.parse(request.responseText);
        const responseData = request.responseText;
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (!callbacks) {
      return;
    }
    if (callbacks.onError) {
      // const responseData = JSON.parse(request.responseText);
      const responseData = request.responseText;
      callbacks.onError(responseData);
    }
  };
  request.send();
};

const updatePassword = (data, callbacks) => {
  const requestUrl = `${digitalUserApi}/password`;
  const request = new XMLHttpRequest();
  request.open('PATCH', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify(data));
};

const updateAccount = (data, callbacks) => {
  const requestUrl = `${digitalUserApi}/account`;
  const request = new XMLHttpRequest();
  request.open('PATCH', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify(data));
};

const createAccount = (data, callbacks) => {
  const requestUrl = `${baseUrl}/usercreateaccount`;
  const request = new XMLHttpRequest();
  request.open('POST', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callbacks.onSuccess) {
        callbacks.onSuccess(responseData);
      }
    }
  };
  request.onerror = () => {
    if (callbacks.onError) {
      const responseData = JSON.parse(request.responseText);
      callbacks.onError(responseData);
    }
  };
  request.send(JSON.stringify({
    data: JSON.stringify(data),
  }));
};

const hasAssets = (callback) => {
  const requestUrl = `${digitalUserApi}/has-assets/${window.userId}`;
  const request = new XMLHttpRequest();
  request.open('GET', requestUrl, true);
  request.setRequestHeader('Content-type', 'application/json');
  request.onload = () => {
    if (request.status >= 200 && request.status < 400) {
      const responseData = JSON.parse(request.responseText);
      if (callback) {
        callback(responseData);
      }
    }
  };
  request.onerror = () => {
    console.log('error');
  };
  request.send();
};

export {
  addVisualization,
  addPhoto,
  addDealer,
  addSwatch,
  addSwatches,
  createAccount,
  forgotPassword,
  getAccountData,
  getItemsByType,
  hasAssets,
  login,
  logout,
  removeItemByType,
  updateAccount,
  updatePassword,
};
/* eslint-enable no-console */
